import React, { createContext, useContext, useEffect, useState } from "react";
import useStateRef from "react-usestateref";
import {
  DOUBT_TITLE,
  EVENTS_LIST,
  PRACTICE_TITLE,
  classifierInitialState,
  LEARN_TITLE,
  fetchGradeName,
} from "../utils/TutorConstants";
import { fetchWelcomeClassifier } from "../api/ai-tutor/Classifier";
import { isEmptyOrNull, isNotEmptyOrNull } from "../utils/common-utils";
import { useRoot } from "./RootContext";
import { StorageService } from "../utils/StorageUtils";
import { AudioProvider } from "./AudioContext";
import { checkISOCREnabled } from "../network/TutorApiService";

const TutorContext = createContext();
const gradeName = "grade 8";
export const TutorProvider = ({ children }) => {
  const {
    subTopicName,
    setSubTopicName,
    isStandalone,
    isRedirectObjectInserted,
    setTtsPlaygroundObj,
    isPlayground,
    setTopicName,
  } = useRoot();
  const [gradeId, setGradeId, gradeIdRef] = useStateRef("");
  const [sectionSyllabus, setSectionSyllabus, sectionSyllabusRef] =
    useStateRef("");
  const [grade, setGrade, gradeRef] = useStateRef("");
  const [subject, setSubject, subjectRef] = useStateRef("");
  const [topic, setTopic, topicRef] = useStateRef("");
  const [loader, setLoader, loaderRef] = useStateRef(false);
  const [classifierInfo, setClassifierInfo, classifierInfoRef] = useStateRef(
    classifierInitialState
  );
  const [isCompleted, setIsCompleted, isCompletedRef] = useStateRef(false);
  const [loaderText, setLoaderText, loaderTextRef] = useStateRef("");
  const [userQuery, setUserQuery, userQueryRef] = useStateRef("");
  const [isDoubt, setIsDoubt, isDoubtRef] = useStateRef(false);
  const [isLearn, setIsLearn, isLearnRef] = useStateRef(false);
  const [isHome, setIsHome, isHomeRef] = useStateRef(false);
  const [
    overAllQuestionResult,
    setOverAllQuestionResult,
    overAllQuestionResultRef,
  ] = useStateRef();
  const [answerCount, setAnswerCount, answerCountRef] = useStateRef();
  const [batteryPercentage, setBatteryPercentage, batteryPercentageRef] =
    useStateRef(0);

  const [journeyId, setJourneyId, journeyIdRef] = useStateRef();
  const [taskStepId, setTaskStepId, taskStepIdRef] = useStateRef();
  const [taskStatus, setTaskStatus, taskStatusRef] = useStateRef("");
  const [taskAnalytics, setTaskAnalytics, taskAnalyticsRef] = useStateRef({});
  const [isTaskCompleted, setIsTaskCompleted, isTaskCompletedRef] =
    useStateRef(false);

  const [openFeedbackModal, setOpenFeedbackModal, openFeedbackModalRef] =
    useStateRef(false);
  const [isFeedbackSubmitted, setIsFeedbackSubmitted, isFeedbackSubmittedRef] =
    useStateRef(false);

  const [subTopicId, setSubtopicId, subTopicIdRef] = useStateRef("");
  const [subtopicMasterUuid, setSubtopicMasterUuid, subtopicMasterUuidRef] =
    useStateRef("");
  const [subTopic, setSubTopic, subTopicRef] = useStateRef("");
  const [subjectId, setSubjectId, subjectIdRef] = useStateRef("");
  const [topicId, setTopicId, topicIdRef] = useStateRef("");
  const [topicMasterUuid, setTopicMasterUuid, topicMasterUuidRef] =
    useStateRef("");
  const [
    experientialLearningData,
    setExperientialLearningData,
    experientialLearningDataRef,
  ] = useStateRef({});
  const [onNextItemSelected, setOnNextItemSelected, onNextItemSelectedRef] =
    useStateRef(true);
  const [subjectMasterUUid, setSubjectMasterUUid, subjectMasterUUidRef] =
    useStateRef("");
  const [selectedTopic, setSelectedTopic, selectedTopicRef] = useStateRef(null);

  const [isPlayerOpen, setIsPlayerOpen, isPlayerOpenRef] = useStateRef(false);
  const [
    selectedFactualIndex,
    setSelectedFactualIndex,
    selectedFactualIndexRef,
  ] = useStateRef();
  const [isFactual, setIsFactual, isFactualRef] = useStateRef(false);

  const [
    isExperientialFromWall,
    setIsExperientialFromWall,
    isExperientialFromWallRef,
  ] = useStateRef(false);

  const [selectedSubTopic, setSelectedSubTopic, selectedSubTopicRef] =
    useStateRef(null);

  const [
    selectedExperiential,
    setSelectedExperiential,
    selectedExperientialRef,
  ] = useStateRef({});
  const [
    isChapterEndAssessment,
    setIsChapterEndAssessment,
    isChapterEndAssessmentRef,
  ] = useStateRef(false);
  const [
    callSameSubTopicAgain,
    setCallSameSubTopicAgain,
    callSameSubTopicAgainRef,
  ] = useStateRef(false);
  const [
    chapterEndAssessmentType,
    setChapterEndAssessmentType,
    chapterEndAssessmentTypeRef,
  ] = useStateRef("proficient");
  const [doubtQuestionObj, setDoubtQuestionObj, doubtQuestionObjRef] =
    useStateRef({});
  const [isOCREnabled, setIsOCREnabled] = useState(false);

  const [triggerHandleSend, setTriggerHandleSend, triggerHandleSendRef] =
    useStateRef(false);
  const [
    isComprehensionQuestion,
    setIsComprehensionQuestion,
    isComprehensionQuestionRef,
  ] = useStateRef(false);

  const [
    isComprehensionDescChat,
    setIsComprehensionDescChat,
    isComprehensionDescChatRef,
  ] = useStateRef("");

  const { selectedIndex, isTutor } = useRoot();

  useEffect(() => {
    if (!isStandalone) {
      setGradeId(StorageService.getItem("gradeId") || "");
      setGrade(fetchGradeName());
    }
  }, []);

  useEffect(() => {
    const type = StorageService.getItem("taskType");
    if (isRedirectObjectInserted || type) {
      setGrade(fetchGradeName());
    }
  }, [isRedirectObjectInserted]);

  useEffect(() => {
    if (!isEmptyOrNull(topic) && (isStandalone || selectedIndex == 2)) {
      handleTriggerClassifier();
    }
  }, [topic]);

  useEffect(() => {
    if (!isEmptyOrNull(topicMasterUuidRef?.current) && isStandalone) {
      setTtsPlaygroundObj((prev) => ({ ...prev, topicID: topicMasterUuidRef?.current }));
      if (isPlayground) {
        setIsOCREnabled(true);
      } else {
        fetchOCRStatus(topicMasterUuidRef?.current);
      }
    }
  }, [topicMasterUuid]);

  const fetchOCRStatus = async (topicID) => {
    const { status, data } = await checkISOCREnabled(topicID);
    if (status == 200) {
      setIsOCREnabled(data?.isOCREnabled || false);
    }
  };

  const handleTriggerClassifier = () => {
    let query = isDoubtRef?.current
      ? DOUBT_TITLE
      : isLearnRef.current
      ? LEARN_TITLE
      : PRACTICE_TITLE;
    setClassifierInfo((prev) => {
      return {
        ...prev,
        classifierQuery: query,
        classifierStatus: isDoubtRef?.current ? 1 : 2,
      };
    });
    handleWelcomeClassifier(query);
  };

  const handleWelcomeClassifier = async (textQuery) => {
    let input = {
      chat_history: [],
      student_response: textQuery || userQueryRef.current,
    };

    setLoader(true);
    let response = await fetchWelcomeClassifier(
      setClassifierInfo,
      setLoader,
      input,
      setIsCompleted
    );
    if (response) {
      const { classifierQuery, classifierText, classifierHistory } =
        classifierInfoRef?.current;
      let existing = [...(classifierHistory || [])];
      if (classifierHistory?.length == 0) {
        existing.push({
          query: classifierQuery,
          answer: classifierText,
        });
      }

      setClassifierInfo((prev) => {
        return {
          ...prev,
          classifierQuery: "",
          classifierText: "",
          classifierHistory: existing,
        };
      });
    }
  };
  const handleUpdateCurriculum = () => {
    setGrade("8");
    setSubject("geography");
    setTopic("Resources");
  };
  const getCurriculumInfo = () => {
    let backUpObject = StorageService.getItem("backUpObject");
    let details = StorageService?.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    return {
      grade: isEmptyOrNull(grade) ? details?.grade_name : grade,
      subject: subjectRef?.current || backUpObject?.subjectName,
      topic_name: topicRef?.current || backUpObject?.topicName,
      grade_id: isEmptyOrNull(gradeId) ? details?.grade : gradeId,
      subject_id:
        subjectMasterUUidRef?.current || backUpObject?.topicMasterUuid,
      topic_name_id:
        topicMasterUuidRef?.current || backUpObject?.topicMasterUuid,
      subtopic_name: subTopicName || backUpObject?.subtopicName,
      subtopic_name_id: isNotEmptyOrNull(selectedTopicRef?.current?.id)
        ? selectedTopicRef?.current?.id
        : subTopicId || backUpObject?.subtopicMasterUuid,
    };
  };
  const handleSetCurriculumDetails = (data) => {
    setGrade(data?.grade?.title);
    setGradeId(data?.grade?.id);
    setSubject(data?.subject?.title);
    setSubjectId(data?.subject?.id);
    setSubjectMasterUUid(data?.subject?.id);
    setTopic(data?.chapter?.title);
    setTopicName(data?.chapter?.title);
    setTopicMasterUuid(data?.chapter?.id);
    setSubTopicName(data?.topic?.title);
    setSubtopicId(data?.topic?.id);
  };

  const state = {
    grade: gradeRef?.current,
    subject: subjectRef?.current,
    topic: topicRef?.current,
    setGrade,
    setSubject,
    setTopic,
    userQuery: userQueryRef?.current,
    setUserQuery,
    setIsCompleted,
    isCompleted: isCompletedRef?.current,
    classifierInfo: classifierInfoRef?.current,
    setClassifierInfo,
    loader: loaderRef?.current,
    setLoader,
    isDoubt: isDoubtRef?.current,
    setIsDoubt,
    isLearn: isLearnRef?.current,
    setIsLearn,
    isHome: isHomeRef?.current,
    setIsHome,
    handleUpdateCurriculum,
    batteryPercentage: batteryPercentageRef?.current,
    curriculumObj: getCurriculumInfo(),
    overAllQuestionResult: overAllQuestionResultRef?.current,
    setOverAllQuestionResult,
    setAnswerCount,
    answerCount: answerCountRef?.current,
    setJourneyId,
    journeyId: journeyIdRef?.current,
    setTaskStepId,
    taskStepId: taskStepIdRef?.current,
    setIsTaskCompleted,
    isTaskCompleted: isTaskCompletedRef?.current,
    taskStatus: taskStatusRef?.current,
    setTaskStatus,
    openFeedbackModal: openFeedbackModalRef?.current,
    setOpenFeedbackModal,
    isFeedbackSubmitted: isFeedbackSubmittedRef?.current,
    setIsFeedbackSubmitted,
    setSectionSyllabus,
    sectionSyllabus: sectionSyllabusRef?.current || [],
    setSubtopicId,
    setSubtopicMasterUuid,
    subtopicMasterUuid: subtopicMasterUuidRef?.current,
    subTopicId: subTopicIdRef.current,
    subjectId: subjectIdRef?.current,
    setSubjectId,
    topicId: topicIdRef.current,
    setTopicId,
    setTopicMasterUuid,
    topicMasterUuid: topicMasterUuidRef.current,
    setSubTopic,
    subTopic: subTopicRef.current,
    setOnNextItemSelected,
    onNextItemSelected: onNextItemSelectedRef?.current,
    setSubjectMasterUUid,
    subjectMasterUUid: subjectMasterUUidRef.current,
    selectedTopic: selectedTopic,
    setSelectedTopic,
    isPlayerOpen: isPlayerOpenRef?.current,
    setIsPlayerOpen,
    isFactual: isFactualRef?.current,
    setIsFactual,
    setSelectedSubTopic,
    selectedSubTopic: selectedSubTopicRef.current,
    setGradeId,
    isChapterEndAssessment: isChapterEndAssessmentRef?.current,
    setIsChapterEndAssessment,
    chapterEndAssessmentType: chapterEndAssessmentTypeRef?.current,
    setChapterEndAssessmentType,
    setCallSameSubTopicAgain,
    callSameSubTopicAgain: callSameSubTopicAgainRef?.current,
    setSelectedExperiential,
    selectedExperiential: selectedExperientialRef?.current,
    setExperientialLearningData,
    experientialLearningData: experientialLearningDataRef?.current,
    setIsExperientialFromWall,
    isExperientialFromWall: isExperientialFromWallRef?.current,
    setTaskAnalytics,
    taskAnalytics: taskAnalyticsRef?.current,
    handleSetCurriculumDetails,
    getCurriculumInfo,
    selectedFactualIndex: selectedFactualIndexRef?.current,
    setSelectedFactualIndex,
    doubtQuestionObj: doubtQuestionObjRef?.current,
    setDoubtQuestionObj,
    loaderText: loaderTextRef?.current,
    setLoaderText,
    isOCREnabled,
    setIsOCREnabled,
    triggerHandleSend: triggerHandleSendRef?.current,
    setTriggerHandleSend,
    isComprehensionQuestion: isComprehensionQuestionRef?.current,
    setIsComprehensionQuestion,
    isComprehensionDescChat: isComprehensionDescChatRef?.current,
    setIsComprehensionDescChat,
  };
  return (
    <TutorContext.Provider value={state}>
      <AudioProvider>{children}</AudioProvider>
    </TutorContext.Provider>
  );
};

export const useTutor = () => {
  return useContext(TutorContext);
};
